import React from "react";
import { useScrollTrigger, useTheme } from "@mui/material"

const ScrollHandler = props => {

  const theme = useTheme();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: props.window ? window() : undefined
  });

  return React.cloneElement(props.children, {
    style: {
      //backgroundColor: trigger ? theme.palette.primary.main : "transparent",
      backgroundColor: trigger ? '#FFF' : 'transparent',
      color: trigger ? theme.palette.primary.main : theme.palette.primary.main,
      transition: trigger ? "0.3s" : "0.5s",
      boxShadow: "none",
      padding: "0px 0px",
      borderRadius:0,
    }
  });
};

const ScrollToColor = props => {
  return <ScrollHandler {...props}>{props.children}</ScrollHandler>;
};

export default ScrollToColor;
